// File: src/App.js
// License: All Rights Reserved
// Copyright (c) 2024 Byron Korir

import React, { useContext, useState} from 'react'
import AddAccommodationDetails from './AddAccommodationDetails'
import AddAccommodationRates from './AddAccommodationRates'
import AddAccommodationPictures from './AddAccommodationPictures'
import AddAccommodationAmenities from './AddAccommodationAmenities'
import { AccommodationContext } from '../context/AccommodationContext'
import LoadingComponent from '../components/LoadingComponent'

export default function AddAccommodation() {
 const {addAccommodation, loading} = useContext(AccommodationContext)
  const [activeTab, setActiveTab] = useState('overview');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  if(loading){
    return(
      <LoadingComponent loadingText={'Adding accommodation ...'} />
    )
  }
  
  return (
    <div className='card ' style={{ backgroundColor: 'rgb(8, 50, 32,1)',minHeight:'100%'}}>
    
      <h2 className="text-center mt-3 mb-4" style={{ fontFamily: 'inknut antiqua', fontWeight: 'bold', color: 'wheat' }}>
        Add Accommodation
        </h2>

        <div className='container-fluid col-md-7 card-body border border-success rounded' >
          
          <div className="col-lg-12 rounded" style={{ backgroundColor: 'rgb(34, 139, 34,0.6)', padding: '20px' }}>
          <div className="d-flex flex-wrap justify-content-around " >
          <p
              className='rounded px-3 '
              style={{ backgroundColor: activeTab === 'overview' ? 'lightgreen' : 'lightgrey', fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => handleTabChange('overview')}
            >
              Details
            </p>

            <p
              className='rounded px-3 '
              style={{ backgroundColor: activeTab === 'itinerary' ? 'lightgreen' : 'lightgrey', fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => handleTabChange('itinerary')}
            >
              Rates
            </p>
            
            <p
              className='rounded px-3 '
              style={{ backgroundColor: activeTab === 'prices' ? 'lightgreen' : 'lightgrey', fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => handleTabChange('prices')}
            >
              Pictures
            </p>
            
            <p
              className='rounded px-3 '
              style={{ backgroundColor: activeTab === 'details' ? 'lightgreen' : 'lightgrey', fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => handleTabChange('details')}
            >
              Amenities
            </p>
            
            <div className=' text-center'>
        <button onClick={addAccommodation} className='btn btn-primary btn-sm' >Create</button>
        </div>
      </div>
          <div className='overflow-auto pt-1 pb-3 mb-0 ' style={{ height: 'fitcontent'}}>
            {activeTab === 'overview' && <AddAccommodationDetails setActiveTab={setActiveTab}/>}
            {activeTab === 'itinerary' && <AddAccommodationRates setActiveTab={setActiveTab}/>}
            {activeTab === 'prices' && <AddAccommodationPictures />}
            {activeTab === 'details' && <AddAccommodationAmenities />}
           
          </div>
          </div>
       
        </div>

    </div>
  )
}

 